<template>
    <section id="page-not-found">
        <b-container fluid>
            <h1 class="mb-4">Legacy STBL Tools</h1>
            <p>The string table <a href="#/ts4-tools/stbl-editor">editor</a> and <a href="#/ts4-tools/stbl-merger">merger</a>
                have been replaced with the new
                <a href="https://stbl.sims4toolkit.com">String Table Studio</a>.
            </p>
            <p>They are preserved on this website. You can access them with the links above.</p>
        </b-container>
    </section>
</template>

<script>
export default {
    name: "HomePage"
}
</script>

<style lang="scss">
#page-not-found {
    height: 90vh;
    width: 100vw;
    display: table-cell;
    vertical-align: middle;
}
</style>
